import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a machinery icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <MachineryIcon width={12} />
 */
const MachineryIcon = props => (
    <SvgIcon {...props}>
        <path d="M19.94 8.18995L16.34 9.83995L14 7.75995V6.21995L16.33 4.13995L19.93 5.78995C20.3 5.95995 20.75 5.79995 20.92 5.41995C21.09 5.03995 20.93 4.59995 20.55 4.42995L16.5 2.57995C16.23 2.45995 15.91 2.49995 15.69 2.69995L13.78 4.39995C13.6 4.15995 13.32 3.99995 13 3.99995C12.45 3.99995 12 4.44995 12 4.99995V5.98995L11.99 5.99995H8.82C8.4 4.83995 7.3 3.99995 6 3.99995C4.34 3.99995 3 5.33995 3 6.99995C3 8.09995 3.6 9.04995 4.48 9.57995L7.08 18H4V21H8H15H17V18H13.38L8.41 8.76995C8.58 8.52995 8.72 8.27995 8.82 7.99995H12V8.99995C12 9.54995 12.45 9.99995 13 9.99995C13.33 9.99995 13.61 9.82995 13.79 9.57995L15.7 11.28C15.84 11.4 16.02 11.47 16.2 11.47C16.31 11.47 16.41 11.45 16.51 11.4L20.56 9.54995C20.94 9.37995 21.1 8.92995 20.93 8.55995C20.76 8.18995 20.31 8.01995 19.94 8.18995ZM6 7.99995C5.45 7.99995 5 7.54995 5 6.99995C5 6.44995 5.45 5.99995 6 5.99995C6.55 5.99995 7 6.44995 7 6.99995C7 7.54995 6.55 7.99995 6 7.99995Z" />
    </SvgIcon>
)

MachineryIcon.defaultProps = defaultProps

export { MachineryIcon }
